import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/products/s10.jpg")